<template>
  <el-dialog
    title="配置结业证书"
    :visible.sync="dialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form :model="form" :rules="rule" ref="form">
      <el-form-item
        label="培训班名称"
        :label-width="formLabelWidth"
      >
        <el-input
          readonly
          v-model="editParams.name"
          autocomplete="off"
          placeholder="请输入培训班名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="证书选择" :label-width="formLabelWidth" prop="graduationId">
        <el-select v-model="form.graduationId" @change='change'>
          <el-option v-for="(item,idx) in selectJson" :key="idx" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="red">
        请谨慎选择证书模版，如果更换证书模版，请在培训班通讯录中，为学员重新申请证书
      </div>
      <el-form-item label="证书内容" :label-width="formLabelWidth" prop='certificateContent'>
        <el-input
          type='textarea'
          v-model="form.certificateContent"
          autocomplete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      
      <el-form-item label="证书样例" :label-width="formLabelWidth">
        <img :src="imgUrl" alt="" style="max-width:300px">
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { addGraduation,getCertificateInfo } from '@/api/api'
export default {
  components: {},
  props: {
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: "130px",
      selectJson:[],
      form: {},
      rule: {
        graduationId: [{ required: true, message: "请选择证书类型", trigger: "blur" }],
        certificateContent: [{ required: true, message: "请输入证书内容", trigger: "blur" }],
      },
      imgUrl:''
    };
  },
  methods: {
    change(id){
        this.selectJson.map((item)=>{
          if( item.id == id ){
            this.imgUrl = item.templateUrl
          }
        })
    },
    setOpacity(flg) {
      this.getData()
      this.dialogVisible = flg;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getData(){
      
            getCertificateInfo({
              templateType : 1
            }).then(res => {
              let { code,data, message } = res;
              if (code === 0) {
                this.selectJson = data;
                if( this.form.graduationId ){
                  this.change(this.form.graduationId)
                }
              } else {
                this.$message.error(message);
              }
            })
    },
    sure(){
      console.log(this.$refs.form)
      this.$refs.form.validate(async (valid) => {
          if (valid) {
            addGraduation({
              id: this.editParams.id,
              ...this.form
            }).then(res => {
              let { code, message } = res;
              if (code === 0) {
                this.$emit('success')
                this.$message.success('配置成功');
                this.dialogVisible = false
              } else {
                this.$message.error(message);
              }
            })
          }
      })
    }
  },
  watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        if( newValue ){
          this.imgUrl = ''
          if( this.editParams.graduationId !== undefined ){
            this.form.graduationId = Number(this.editParams.graduationId)
            this.$set(this.form,'certificateContent',this.editParams.certificateContent)
            // this.form.certificateContent = 
          }else{
            this.form = {}
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">

.el-dialog__body {
  // max-height: 50vh;
  overflow-y: auto;
}
.red{
  color: red;
  margin-left: 130px;
}
</style>
